import {
  ContentWorkflow,
  getSLADueDate,
  isNearSLADueDate,
  isPastSLADueDate,
} from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import '../../resources/styles/scss/components/workflow-viewer/workflow-viewer.scss';
import { Badge } from '@amzn/awsui-components-core';

interface WorkflowSLADueDateProps {
  workflow: ContentWorkflow;
}

const WorkflowSLADueDate = ({ workflow }: WorkflowSLADueDateProps) => {
  const slaDueDate = getSLADueDate(workflow);
  if (!slaDueDate || slaDueDate === 0 || null) {
    return null;
  }
  const isPastSLA = isPastSLADueDate(slaDueDate);
  const isNearSLA = isNearSLADueDate(slaDueDate);
  const parsedSLA = new Date(slaDueDate).toISOString().substring(0, 10);
  const slaDueBackgroundColor = isNearSLA
    ? 'severity-medium'
    : isPastSLA
      ? 'severity-high'
      : 'severity-neutral';

  return <Badge color={slaDueBackgroundColor}>{parsedSLA}</Badge>;
};

export default WorkflowSLADueDate;
